import React, { Component } from "react";
import tooltipIcon from "../../../assets/tooltip.png";
import { isMobile } from "../../../utils/deviceInfo";

export class Tooltip extends Component {
  render() {
    const { customHeight, customWidth, customMarginLeft } = this.props;
    return (
      <img
        src={tooltipIcon}
        alt="tooltip"
        style={{
          height: customHeight ? customHeight : isMobile? "14px":"18px",
          width: customWidth ? customWidth :  isMobile? "14px":"18px",
          cursor: "pointer",
          marginLeft: customMarginLeft ? customMarginLeft : isMobile?"4px": "10px",
        }}
      />
    );
  }
}
export default Tooltip;
